import Timestamp from "components/Timestamp";
import Note from "ds/components/Note";
import { Stack } from "types/generated";

type LockNoticeProps = {
  lockedAt: Stack["lockedAt"];
  lockedBy: Stack["lockedBy"];
  note?: Stack["lockNote"];
  viewer: string;
};

const LockNotice = ({ lockedAt, lockedBy, note, viewer }: LockNoticeProps) => (
  <Note
    title={
      <>
        This stack was locked for exclusive use by {lockedBy === viewer ? "yourself" : lockedBy}
        {lockedAt && (
          <>
            &nbsp;on&nbsp;
            <Timestamp timestamp={lockedAt} />
          </>
        )}
        .
      </>
    }
    content={note}
    variant="disabled"
  />
);

export default LockNotice;
